/**
 * Hook to show a warning message when a request is taking longer than expected
 * Useful for cold start scenarios on free tier backends
 */

import { useState, useEffect, useRef } from 'react';

export function useSlowRequestWarning(isLoading, delay = 2000) {
  const [showWarning, setShowWarning] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (isLoading) {
      // Start timer when loading begins
      timerRef.current = setTimeout(() => {
        setShowWarning(true);
      }, delay);
    } else {
      // Clear timer and hide warning when loading completes
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      setShowWarning(false);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [isLoading, delay]);

  return showWarning;
}
